import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

const isNative = Capacitor.isNativePlatform();

export const useHaptics = () => {
  const impact = async (style: ImpactStyle = ImpactStyle.Medium) => {
    if (!isNative) return;
    try {
      await Haptics.impact({ style });
    } catch {}
  };

  const notification = async (type: NotificationType = NotificationType.Success) => {
    if (!isNative) return;
    try {
      await Haptics.notification({ type });
    } catch {}
  };

  const selectionStart = async () => {
    if (!isNative) return;
    try {
      await Haptics.selectionStart();
    } catch {}
  };

  const selectionChanged = async () => {
    if (!isNative) return;
    try {
      await Haptics.selectionChanged();
    } catch {}
  };

  const selectionEnd = async () => {
    if (!isNative) return;
    try {
      await Haptics.selectionEnd();
    } catch {}
  };

  return {
    impact,
    notification,
    selectionStart,
    selectionChanged,
    selectionEnd,
    lightTap: () => impact(ImpactStyle.Light),
    mediumTap: () => impact(ImpactStyle.Medium),
    heavyTap: () => impact(ImpactStyle.Heavy),
    success: () => notification(NotificationType.Success),
    warning: () => notification(NotificationType.Warning),
    error: () => notification(NotificationType.Error),
  };
};
